/*eslint no-undef: "error"*/
import $ from "jquery";

const simpleQuestion = () => {
  const init = () => {
    disableNextChapter();
    // submitSimpleQuestion();
  };

  // const submitSimpleQuestion = () => {
  //   $(function () {
  //     $(".submit-simple-question").on("click", function () {

  //       let answer = $("[open=open] .answer-question").val();
  //       console.log(answer);
  //       let question_title = $(".question_title").val();
  //       let question_id = $(".question_id").val();

  //       let data = {
  //         'answer': answer,
  //         'question_title': question_title,
  //         'question_id': question_id

  //       };

  //       let postData = {
  //         'nonce': 'n0nc3',
  //         'action': 'save_simple_question',
  //         'data': data
  //       };


  //       // $.ajax({
  //       //   type: 'POST',
  //       //   // eslint-disable-next-line no-undef
  //       //   url: themeParams.ajaxUrl,
  //       //   data: postData,
  //       //   dataType: "json", // and this
  //       //   success: function () {
  //       //     localStorage.removeItem('progress');
  //       //   },
  //       //   error: function () {
  //       //   }
  //       // });
  //     });

  //   });
  // }

  function disableNextChapter() {
    $(function () {

      if ($('textarea[name="question"].simple_question').length < 1) return;
      $('.Chapter__Content--SimpleQuestion textarea[name="question"].simple_question').each(function () {
        let answer = $(this)
        let question_id = $(this).siblings('input.question_id').val()
        let question_title = $(this).siblings('input.question_title').val()

        $(this).closest('.mi-ChapterContent__Question_Wrapper').find('.mi-NavigatorChapter__Question--Simple .submit-simple-question').on("click", function () {
          // console.log( answer.val(), question_id, question_title)
          let data = {
            'answer': answer.val(),
            'question_title': question_title,
            'question_id': question_id

          };

          let postData = {
            'nonce': 'n0nc3',
            'action': 'save_simple_question',
            'data': data
          };


          $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: themeParams.ajaxUrl,
            data: postData,
            dataType: "json", // and this
            success: function () {
              localStorage.removeItem('progress');
              $(`h3#parent-${question_id}`).find(".question-before").html(`${data.question_title}`);
              $(`h3#parent-${question_id}`).find(".answer-before").html(`${data.answer}`);
            },
            error: function () {
            }
          });

        })

        //disable the Next button initially
        if ($(this).val().trim() !== "") {
          $($(this).closest('.Chapter__Content--SimpleQuestion').find('.next-chapter-question')).prop("disabled", false);
        } else {
          //disable the Next button if the question hasn't been answered
          $($(this).closest('.Chapter__Content--SimpleQuestion').find('.next-chapter-question')).prop("disabled", true);
        }

        //add an event listener to the textarea
        $($(this)).on("input", function () {
          //check if the question has been asnwered
          if ($(this).val().trim() !== "") {
            $($(this).closest('.Chapter__Content--SimpleQuestion').find('.next-chapter-question')).prop("disabled", false);
          } else {
            //disable the Next button if the question hasn't been answered
            $($(this).closest('.Chapter__Content--SimpleQuestion').find('.next-chapter-question')).prop("disabled", true);
          }
        });

        $($(this).closest('.Chapter__Content--SimpleQuestion').find('.next-chapter-question')).on('click', function () {
        })
      })

    });
  }

  init();
};

try {
  simpleQuestion();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log('This File Error:', error);
}


